import Reporting from ".";
import { REPORT_SECTIONS } from "./utils";

/**
 * The "PDF Generator" section: the same queued-report module as Reporting,
 * showing only the brochure documents. Mounted at `/pdf-generator` so the two
 * sections have their own place in the module switcher and their own
 * destination for the header notifications.
 */
const PdfGeneratorSection = props => (
  <Reporting {...props} section={REPORT_SECTIONS.PDF_GENERATOR} />
);

export default PdfGeneratorSection;
